export default "__VITE_ASSET__d36ccb7b__"